import { useMemo } from 'react'
import { useQuery, type UseQueryOptions, type UseQueryResult } from '@tanstack/react-query'
import { type GQLError } from '@egw/clients'
import { type HistoricalStockPricesInput, type HistoricalStockPricesOutput } from '../../models'
import { getHistoricalStockPrices } from '../../services'

export const useHistoricalStockPrices = (
  historicalStockPricesInput: HistoricalStockPricesInput,
  options?: Omit<UseQueryOptions<HistoricalStockPricesOutput, GQLError>, 'queryKey' | 'queryFn' | 'select'>,
): UseQueryResult<HistoricalStockPricesOutput, GQLError> => {
  const queryKey = useMemo(() => ['historicalStockPrices', historicalStockPricesInput], [historicalStockPricesInput])

  return useQuery<HistoricalStockPricesOutput, GQLError>({
    queryKey,
    queryFn: () => getHistoricalStockPrices(historicalStockPricesInput),
    ...options,
  })
}
